/* eslint-disable */

import moment from 'moment'
import _ from 'lodash'

import { mapState, mapGetters } from 'vuex'

import { Tag } from '@/types/tag'

interface MapTag {
  [name: string]: Tag
}

const svgTemplate = {
  name: 'HawaPanelSVG',
  template: '<div></div>',
  data() {
    return {
      company: 'Gaman Lab',
      settings: {
        timeFormat: 'HH:mm:ss',
        dateFormat: 'DD MMMM YYYY',
      },
      internal: {
        timeString: '',
        dateString: '',
      },
      timers: {
        cyclic1s: undefined,
      },
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isOperator', 'isStandarUser', 'isSuperAdmin']),
    ...mapState(['local', 'server']),
    tags(): MapTag {
      const self: any = this
      const tags: MapTag = {}
      for (const uid in self.$store.state.tag.items) {
        const tag: Tag = self.$store.state.tag.items[uid]
        tags[tag.name] = tag
      }

      return tags
    },
  },
  methods: {
    cyclic1s() {
      const self: any = this
      self.internal.timeString = moment().format(self.settings.timeFormat)
      self.internal.dateString = moment().format(self.settings.dateFormat)

      self.setRealtimeValue()
      self.timers.cyclic1s = setTimeout(() => {
        this.cyclic1s()
      }, 500)
    },

    goto(path: string) {
      const self: any = this
      if (self.$route.path == path) {
        return
      }
      self.$router.push(path)
    },

    async userLogout() {
      await (this as any).$store.dispatch('user/logout')
      ;(this as any).$router.push({ path: '/login' })
    },

    setRealtimeValue() {
      const self: any = this

      for (const ref in self.$refs) {
        const tagsCheck = ref.split('.')

        let target: any

        if (tagsCheck[0] == 'tags' && tagsCheck.length == 2) {
          target = _.get(self, ref + '.value', '####')
        } else {
          target = _.get(self, ref, '#####')
        }

        if (target != '#####') {
          // const tag: Tag = self.tags[ref]
          // if (tag == undefined) {
          //   continue
          // }

          const precision = self.$refs[ref].getAttribute('precision')
          if (
            precision != undefined &&
            precision != '' &&
            typeof target == 'number'
          ) {
            try {
              const prec = parseInt(precision)
              self.$refs[ref].innerHTML = target.toFixed(prec)
              continue
            } catch {
              //
            }
          }
        }

        self.$refs[ref].innerHTML = target
      }
    },

    getBit(tagName: string, bitPosition: number): boolean {
      const val = _.get((this as any).tags, tagName + '.value', '####')
      if (typeof val == 'number') {
        return (val & (1 << bitPosition)) === 0 ? false : true
      }

      return false
    },

    EQ(tagName: string, cmp: number): boolean {
      const val = _.get((this as any).tags, tagName + '.value', '####')

      return val == cmp
    },
    GT(tagName: string, cmp: number): boolean {
      const val = _.get((this as any).tags, tagName + '.value', '####')

      return val > cmp
    },
    GE(tagName: string, cmp: number): boolean {
      const val = _.get((this as any).tags, tagName + '.value', '####')

      return val >= cmp
    },
  },

  created() {
    const self: any = this
  },

  mounted() {
    const self: any = this
    self.cyclic1s()

    // self.setRealtimeValue()
  },

  destroyed() {
    const self: any = this
    if (self.timers.cyclic1s) {
      clearTimeout(self.timers.cyclic1s)
    }
    // console.log('Destroyed')
  },
}

export default svgTemplate
